import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  cellWrap: {
    position: 'relative',
    width: '100%',
  },
  trigger: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    width: '100%',
    minHeight: 44,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 14,
    color: '#111827',
    borderRadius: 8,
    '&:hover': {
      background: 'rgba(25, 118, 210, 0.08)',
    },
  },
  placeholder: {
    color: '#9ca3af',
  },
  offTrigger: {
    background: 'rgba(107, 114, 128, 0.12)',
    '&:hover': {
      background: 'rgba(107, 114, 128, 0.2)',
    },
  },
  holidayTrigger: {
    background: 'rgba(245, 158, 11, 0.16)',
    '&:hover': {
      background: 'rgba(245, 158, 11, 0.24)',
    },
  },
  selectionTrigger: {
    outline: '1px dashed rgba(25, 118, 210, 0.45)',
    '&:hover': {
      background: 'rgba(25, 118, 210, 0.16)',
    },
  },
  selectedTrigger: {
    outline: '2px solid #1976d2',
    background: 'rgba(25, 118, 210, 0.16)',
  },
  offLabel: {
    fontWeight: 700,
    color: '#4b5563',
  },
  holidayLabel: {
    fontWeight: 700,
    color: '#b45309',
  },
  duration: {
    fontSize: 12,
    fontWeight: 600,
    color: '#1976d2',
  },
  deleteButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 22,
    height: 22,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: '#9ca3af',
    fontSize: 16,
    lineHeight: 1,
    padding: 0,
    borderRadius: 4,
    '&:hover': {
      color: '#d32f2f',
      background: 'rgba(211, 47, 47, 0.08)',
    },
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  dayMarks: {
    display: 'flex',
    gap: 8,
    marginBottom: 16,
  },
  timeDisplay: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    gap: 4,
    marginTop: 12,
    fontVariantNumeric: 'tabular-nums',
  },
  timeUnit: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 48,
    lineHeight: 1,
    fontWeight: 500,
    color: '#9ca3af',
    padding: '0 4px',
    borderRadius: 8,
    '@media (max-width: 480px)': {
      fontSize: 40,
    },
  },
  activeUnit: {
    color: '#1976d2',
  },
  timeSeparator: {
    fontSize: 48,
    lineHeight: 1,
    color: '#111827',
  },
  clockWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 8,
  },
});
